import { Box, FormControl, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { Button } from "@mui/material";
import parse from "html-react-parser";
import {
  INSPECTION_STATUS,
  SIGNOFF_METHOD_TYPE,
} from "../../../../constant/constant";
import DailyReportView from "./dailyReportView";
import commonImages from "../../../../assets";
import "../../../inspections/view-inspection-report/common/common.scss";
import NewOpenItem from "./newOpenItem";
import PreviousOpenItem from "./previousOpenItem";
import ViewNorthCarolina from "./addReport/viewNorthCarolina";
import BackBtn from "../../../../library/custom/backBtn/backBtn";
import {
  getValueByKey,
  isExtraContent,
  phaseProjectColumns,
  rainfallColumns,
  siteComplianceAnsViewColumns,
} from "../../../../utils/swInspectionHelper";
import ViewThreeQuestion from "./addReport/viewThreeQuestion";
import { formatRainfall, getYesNoValue } from "../../../../utils/helper";
import DynamicTable from "../../../../library/custom/dynamicTable/dynamicTable";
import ViewSouthCarolina from "./addReport/viewSouthCarolina";

const ViewReport = ({
  inspectionDetail,
  handlePrint,
  getInTyFeByInTyList,
  isNorthCarolina,
  userInfo,
  isTennessee,
  isSouthCarolina,
}) => {
  const reportId = inspectionDetail?.report_Id;

  const findCount = (detailCont) => {
    const statusCount = detailCont?.reduce((count, obj) => {
      if (obj.status === INSPECTION_STATUS?.Open) {
        return count + 1;
      }
      return count;
    }, 0);
    return <div>{statusCount}</div>;
  };
  const [currentMonthName, setCurrentMonthName] = useState();
  useEffect(() => {
    const currentDate =
      inspectionDetail?.dailyReportInspectionDetails &&
      inspectionDetail?.dailyReportInspectionDetails[0]?.date;
    const dateObject = new Date(currentDate);
    const findMonthName = dateObject?.toLocaleString("default", {
      month: "long",
    });
    setCurrentMonthName(findMonthName);
  }, [inspectionDetail]);

  const dailyReportHeader = {
    projectName: inspectionDetail?.projectName,
    projectLocation: inspectionDetail?.address,
    monthOfInspection: currentMonthName,
    logId: inspectionDetail?.report_Id,
  };

  const dataBack = {
    title: "Back",
    route: -1,
  };

  return (
    <div className="pdfInnerOverRide">
      {inspectionDetail?.dailyReportInspectionDetails !== null && (
        <DailyReportView
          dailyReportInspectionDetails={
            inspectionDetail?.dailyReportInspectionDetails
          }
          dailyReportHeader={dailyReportHeader}
        />
      )}
      {inspectionDetail?.dailyReportInspectionDetails === null && (
        <>
          <div className="overReportHeader">
            <Grid container className="reportHeader  ">
              <Grid md={6} sm={6} xs={12} className="reportHeaderLeft">
                <div className="reportTitle inspectionHeader">
                  Report ID: <span>{inspectionDetail?.report_Id}</span>
                </div>
                {getInTyFeByInTyList?.map((field) => {
                  if (field?.key === 1 && field.isSelected) {
                    return (
                      <div
                        className="reportTitle inspectionHeader"
                        key={field.key}
                      >
                        Project Name:{" "}
                        <span>{inspectionDetail?.projectName}</span>
                      </div>
                    );
                  }
                })}
              </Grid>
              <Grid md={4} sm={4} xs={4} className="reportHeaderLeft right">
                {/* <div className="reportTitle right">
                  {inspectionDetail?.inspectionType}
                </div> */}
              </Grid>
              <Grid md={2} sm={2} xs={8} className="reportHeaderLeft right">
                <div className="hbLogo">
                  <img src={commonImages?.hbNextLogo} alt="" />
                </div>
              </Grid>
              <Grid md={12} xs={12}>
                <div>
                  <Button
                    onClick={handlePrint}
                    variant="contained"
                    startIcon={<DownloadIcon className="downloadIcon" />}
                    className="downloadpdf sw marginRemove"
                  >
                    Download as PDF
                  </Button>
                </div>
              </Grid>
            </Grid>
          </div>

          <div className="basicOveride">
            <Box className="basicinfoWrap removeBorderRadius">
              <Box className="basicinfoBox">
                <Box className="basicinfoleft sw">
                  <div className="info-report">
                    <Typography className="title removeInPdf">
                      Basic Information:
                    </Typography>
                  </div>

                  <Grid container item>
                    {getInTyFeByInTyList
                      ?.filter((field) => field.isSelected)
                      .sort((a, b) => a.sequenceNumber - b.sequenceNumber)
                      .map((field) => {
                        if (field?.key === 9 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Client:",
                                  inspectionDetail?.clientName,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView printListView">
                                Client:
                                <span>{inspectionDetail?.clientName}</span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 1 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Project:",
                                  inspectionDetail?.projectName,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView printListView">
                                Project:
                                <span>{inspectionDetail?.projectName}</span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 33 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Frequency:",
                                  inspectionDetail?.frequencyInDays,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView printListView">
                                Frequency:
                                <span>{inspectionDetail?.frequency}</span>
                              </Typography>

                              {inspectionDetail?.frequency?.toLowerCase() ===
                                "custom" && (
                                <Typography className="listView">
                                  Frequency In Days:
                                  <span>
                                    {inspectionDetail?.frequencyInDays}
                                  </span>
                                </Typography>
                              )}
                            </Grid>
                          );
                        } else if (field?.key === 34 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Inspection name:",
                                  inspectionDetail?.questionSetName,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView printListView">
                                Inspection name:
                                <span>{inspectionDetail?.questionSetName}</span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 8 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Report ID:",
                                  inspectionDetail?.report_Id,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView printListView">
                                Report ID:
                                <span>{inspectionDetail?.report_Id}</span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 35 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Last Date of Inspection:",
                                  inspectionDetail?.lastDateOfInspection,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView">
                                Last Date of Inspection:
                                <span>
                                  {inspectionDetail?.lastDateOfInspection}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 12 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Inspection Type:",
                                  inspectionDetail?.inspectionType,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView">
                                Inspection Type:
                                <span>{inspectionDetail?.inspectionType}</span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 2 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Project Number:",
                                  inspectionDetail?.projectNumber,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView">
                                Project Number:
                                <span>{inspectionDetail?.projectNumber}</span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 13 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Inspected By:",
                                  inspectionDetail?.inspectorName,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView">
                                Inspected By:
                                <span className="focusedText">
                                  {inspectionDetail?.inspectorName}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 21 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Inspector's phone number:",
                                  inspectionDetail?.inspectorContactNumber,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                Inspector's phone number:
                                <span>
                                  {inspectionDetail?.inspectorContactNumber}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 36 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Inspector's Email:",
                                  inspectionDetail?.inspectorEmail,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                Inspector's Email:
                                <span>{inspectionDetail?.inspectorEmail}</span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 10 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Date of Inspection:",
                                  inspectionDetail?.dateOfInspection,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView">
                                Date of Inspection:
                                <span>
                                  {inspectionDetail?.dateOfInspection}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 3 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Time of Inspection:",
                                  inspectionDetail?.timeOfInspection,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView">
                                Time of Inspection:
                                <span>
                                  {inspectionDetail?.timeOfInspection}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 4 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Weather at Time of Inspection:",
                                  inspectionDetail,
                                )?.weather
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView">
                                Weather at Time of Inspection:
                                <span>
                                  {inspectionDetail?.weather
                                    ? inspectionDetail?.weather
                                    : "N/A"}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 17 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Soil condition:",
                                  inspectionDetail?.soilType,
                                )
                                  ? 12
                                  : 12
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView">
                                Soil condition:
                                <span>
                                  {inspectionDetail?.soilType
                                    ? inspectionDetail?.soilType
                                    : "N/A"}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 14 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Stage of Construction:",
                                  inspectionDetail?.constructionStage,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                Stage of Construction:
                                <span>
                                  {parse(
                                    unescape(
                                      inspectionDetail?.constructionStage
                                        ? inspectionDetail?.constructionStage
                                        : "N/A",
                                    ),
                                  )}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 6 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Sample Taken:",
                                  inspectionDetail?.isSampleTaken,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView">
                                Sample Taken:
                                <span>
                                  {inspectionDetail?.isSampleTaken
                                    ? "Yes"
                                    : "No"}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 5 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  " Rainfall Amount (inches):",
                                  inspectionDetail?.rainfall,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView">
                                Rainfall Amount (inches):
                                <span>
                                  {inspectionDetail?.rainfall !== null
                                    ? formatRainfall(inspectionDetail?.rainfall)
                                    : "N/A"}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 16 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Current approximate disturbed acreage:",
                                  inspectionDetail?.disturbedAcreage,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                Current approximate disturbed acreage:
                                <span>
                                  {parse(
                                    unescape(
                                      inspectionDetail?.disturbedAcreage
                                        ? inspectionDetail?.disturbedAcreage
                                        : "N/A",
                                    ),
                                  )}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 19 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Site Name:",
                                  inspectionDetail?.siteName,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                Site Name:
                                <span>
                                  {inspectionDetail?.isStandAloneProject ===
                                  false
                                    ? inspectionDetail?.siteName
                                    : "N/A"}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 18 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Construction Activity:",
                                  inspectionDetail?.constructionActivity,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                Construction Activity:
                                <span>
                                  {inspectionDetail?.constructionActivity
                                    ? inspectionDetail?.constructionActivity
                                    : "N/A"}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 20 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  " Division:",
                                  inspectionDetail?.divisionName,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                Division:
                                <span>{inspectionDetail?.divisionName}</span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 22 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Company performing inspection",
                                  inspectionDetail?.inspectorCompanyName,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                Company performing inspection:
                                <span>
                                  {inspectionDetail?.inspectorCompanyName}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 23 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Project Status:",
                                  inspectionDetail?.projectStatus,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                Project Status:
                                <span>
                                  {inspectionDetail?.projectStatus
                                    ? "Active"
                                    : "Inactive"}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 24 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "State:",
                                  inspectionDetail?.state,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                State:
                                <span>{inspectionDetail?.state}</span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 25 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Address:",
                                  inspectionDetail?.address,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                Address:
                                <span>
                                  {inspectionDetail?.address
                                    ? inspectionDetail?.address
                                    : "N/A"}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 27 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent("Job title:", userInfo?.jobTitle)
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                Job title:
                                <span>
                                  {inspectionDetail?.jobtitle
                                    ? inspectionDetail?.jobtitle
                                    : "N/A"}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 26 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Certification Number:",
                                  inspectionDetail?.certificationNumber,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                Certification Number:
                                <span>
                                  {inspectionDetail?.certificationNumber
                                    ? inspectionDetail?.certificationNumber
                                    : "N/A"}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 39 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={12}
                              xs={12}
                              className="companyPerforming"
                            >
                              <div className="companyPerformingTitle">
                                Company Performing Inspection Address
                              </div>
                              <div className="companyPerforming">
                                Address Line 1:{" "}
                                <span>
                                  {" "}
                                  {inspectionDetail.inspectorAddress1 || "N/A"}
                                </span>
                              </div>
                              {inspectionDetail.inspectorAddress2 &&
                                inspectionDetail.inspectorAddress2 !==
                                  "N/A" && (
                                  <div className="companyPerforming">
                                    Address Line 2:{" "}
                                    <span>
                                      {" "}
                                      {inspectionDetail.inspectorAddress2}
                                    </span>
                                  </div>
                                )}
                              <div className="companyPerforming columnBox">
                                <div className="column">
                                  State:{" "}
                                  <span>
                                    {" "}
                                    {inspectionDetail.inspectorState || "N/A"}
                                  </span>
                                </div>
                                <div className="column">
                                  City:{" "}
                                  <span>
                                    {inspectionDetail.inspectorCity || "N/A"}
                                  </span>
                                </div>
                              </div>
                              <div className="companyPerforming">
                                Zip Code:{" "}
                                <span>
                                  {inspectionDetail.inspectorZipCode || "N/A"}
                                </span>
                              </div>
                            </Grid>
                          );
                        }
                      })}
                  </Grid>

                  {(() => {
                    const permitFields = [7, 15, 28, 37, 38];
                    const selectedPermitFields = getInTyFeByInTyList?.filter(
                      (field) =>
                        permitFields.includes(field.key) && field.isSelected,
                    );

                    if (selectedPermitFields?.length > 0) {
                      return (
                        <Grid
                          item
                          md={12}
                          xs={12}
                          className="northCarolinaOverride"
                        >
                          <div className="commonTableBoxNorth">
                            <div className="commonTableBoxNorthTitle">
                              Permit Details
                            </div>
                            <div className="tableWrapper">
                              <table>
                                <thead>
                                  <tr className="tableHead">
                                    {selectedPermitFields.find(
                                      (f) => f.key === 7,
                                    ) && <th>Permit Number</th>}
                                    {selectedPermitFields.find(
                                      (f) => f.key === 15,
                                    ) && <th>Permit Enforcement</th>}
                                    {selectedPermitFields.find(
                                      (f) => f.key === 28,
                                    ) && <th>Permittee Address</th>}
                                    {selectedPermitFields.find(
                                      (f) => f.key === 37,
                                    ) && <th>Permit Approval Date</th>}
                                    {selectedPermitFields.find(
                                      (f) => f.key === 38,
                                    ) && <th>Permit Expiration Date</th>}
                                  </tr>
                                </thead>
                                <tbody>
                                  {inspectionDetail?.listPermitte?.length >
                                  0 ? (
                                    inspectionDetail?.listPermitte.map(
                                      (x, index) => (
                                        <tr className="tableBody" key={index}>
                                          {selectedPermitFields.map((field) => {
                                            let value = "N/A";
                                            switch (field.key) {
                                              case 7:
                                                value =
                                                  x.permitteOrNPDESNumber ||
                                                  "N/A";
                                                break;
                                              case 15:
                                                value =
                                                  x.permitteEnforcement ||
                                                  "N/A";
                                                break;
                                              case 28:
                                                value =
                                                  x.permitteAddress || "N/A";
                                                break;
                                              case 37:
                                                value =
                                                  x.permitteApprovalDate ||
                                                  "N/A";
                                                break;
                                              case 38:
                                                value =
                                                  x.permitteExpirationDate ||
                                                  "N/A";
                                                break;
                                              default:
                                                value = "N/A";
                                            }
                                            return (
                                              <td key={field.key}>{value}</td>
                                            );
                                          })}
                                        </tr>
                                      ),
                                    )
                                  ) : (
                                    <tr>
                                      {selectedPermitFields.map(
                                        (_, colIndex) => (
                                          <td key={colIndex}>N/A</td>
                                        ),
                                      )}
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </Grid>
                      );
                    }
                    return null;
                  })()}

                  <Grid container item>
                    {getInTyFeByInTyList
                      ?.filter((field) => field.isSelected)
                      .sort((a, b) => a.sequenceNumber - b.sequenceNumber)
                      .map((field) => {
                        if (field?.key === 30 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Site Assessment:",
                                  inspectionDetail?.siteAssessment,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                Site Assessment:
                                <span>
                                  {inspectionDetail?.siteAssessment &&
                                  parseInt(inspectionDetail?.siteAssessment) ===
                                    1
                                    ? "Yes"
                                    : parseInt(
                                          inspectionDetail?.siteAssessment,
                                        ) === 2
                                      ? "No"
                                      : "N/A"}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 31 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Assessor's TN PE registration number:",
                                  inspectionDetail?.tnpeNumber,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                Assessor's TN PE registration number:
                                <span>
                                  {inspectionDetail?.tnpeNumber
                                    ? inspectionDetail?.tnpeNumber
                                    : "N/A"}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 32 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Assessor's TNEPSC Level II / CPESC number:",
                                  inspectionDetail?.cpescNumber,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                Assessor's TNEPSC Level II / CPESC number:
                                <span>
                                  {inspectionDetail?.cpescNumber
                                    ? inspectionDetail?.cpescNumber
                                    : "N/A"}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        } else if (field?.key === 29 && field.isSelected) {
                          return (
                            <Grid
                              item
                              md={
                                isExtraContent(
                                  "Has rainfall been checked/documented daily:",
                                  inspectionDetail?.isRainfallChecked,
                                )
                                  ? 12
                                  : 6
                              }
                              xs={12}
                              key={field.key}
                            >
                              <Typography className="listView desNone borderAdd">
                                Has rainfall been checked/documented daily:
                                <span>
                                  {inspectionDetail?.isRainfallChecked === true
                                    ? "Yes"
                                    : inspectionDetail?.isRainfallChecked ===
                                        false
                                      ? "No"
                                      : "N/A"}
                                </span>
                              </Typography>
                            </Grid>
                          );
                        }
                      })}
                  </Grid>

                  <Typography className="listView desNone">
                    General Comments:
                    <span>
                      {inspectionDetail?.comment
                        ? parse(unescape(inspectionDetail?.comment))
                        : "N/A"}
                    </span>
                  </Typography>
                </Box>
              </Box>
            </Box>
          </div>

          {(isNorthCarolina || isSouthCarolina) && (
            <>
              <DynamicTable
                title="7-Day Rainfall Data"
                columns={rainfallColumns}
                data={inspectionDetail?.swInspectionRainfallData}
                initialName={
                  inspectionDetail?.inspectorName
                    ? inspectionDetail?.inspectorName
                        ?.split(" ")
                        ?.map((word) => word.charAt(0).toUpperCase())
                        ?.join("")
                    : ""
                }
              />

              <div className="dynamic-table">
                <h3>Current Phase of Project</h3>
                <table>
                  <thead>
                    <tr>
                      <th>
                        Check ALL applicable box(es) that apply to completed &
                        current phases{" "}
                      </th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inspectionDetail?.swInspectionCurrentProjectPhase?.map(
                      (item) => {
                        return (
                          <tr className="CurrentProjectPhasetable">
                            <td className="optinCheck">
                              <div className="optinValue">
                                {item?.optionName}
                              </div>
                              <div className="optinStatus">
                                {item?.isChecked ? (
                                  <svg
                                    width="22"
                                    height="22"
                                    viewBox="0 0 22 22"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M9.40625 15.5L16.8438 8.09375L15.25 6.5L9.40625 12.3125L6.75 9.6875L5.15625 11.2812L9.40625 15.5ZM2.75 21.5C2.13125 21.5 1.60156 21.2797 1.16094 20.8391C0.720312 20.3984 0.5 19.8687 0.5 19.25V2.75C0.5 2.13125 0.720312 1.60156 1.16094 1.16094C1.60156 0.720313 2.13125 0.5 2.75 0.5H19.25C19.8687 0.5 20.3984 0.720313 20.8391 1.16094C21.2797 1.60156 21.5 2.13125 21.5 2.75V19.25C21.5 19.8687 21.2797 20.3984 20.8391 20.8391C20.3984 21.2797 19.8687 21.5 19.25 21.5H2.75Z"
                                      fill="#1B436E"
                                    />
                                  </svg>
                                ) : (
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      x="1"
                                      y="1"
                                      width="18"
                                      height="18"
                                      rx="1"
                                      stroke="#1B436E"
                                      strokeWidth="2"
                                    />
                                  </svg>
                                )}
                              </div>
                            </td>
                            <td className="statusBox">
                              {item?.status === 1
                                ? "In Progress"
                                : item?.status === 2
                                  ? "Completed"
                                  : item?.status === 3
                                    ? "Other"
                                    : "N/A"}
                              {item?.status != 0 && (
                                <div>
                                  {parse(unescape(item?.comment || ""))}
                                </div>
                              )}
                            </td>
                          </tr>
                        );
                      },
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}
          {isTennessee && (
            <DynamicTable
              title=""
              columns={siteComplianceAnsViewColumns}
              data={inspectionDetail?.swInspectionSiteComplianceAnsView}
              checkbox={true}
            />
          )}
          {isTennessee && (
            <>
              <Grid container mt={3}>
                <Grid item xs={12} sm={12} className="confQuestionAns" mb={2}>
                  <strong>
                    {
                      "Are all applicable EPSCs installed and maintained per the SWPPP per the current phase?"
                    }
                    :
                  </strong>
                  {getYesNoValue(inspectionDetail?.epscInstalled)}
                </Grid>

                <Grid item xs={12} sm={12} className="confQuestionAns" mb={2}>
                  <strong>
                    {
                      "Are EPSCs functioning correctly at all disturbed areas/material storage areas?"
                    }
                    :
                  </strong>
                  {getYesNoValue(inspectionDetail?.epscFunctioning)}
                </Grid>
              </Grid>
            </>
          )}
          {(isNorthCarolina || isSouthCarolina) && (
            <>
              <Grid container mt={3}>
                {inspectionDetail?.swInspectionConfQuestionAns
                  ?.slice(2, 4)
                  ?.map((item) => {
                    return (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        className="confQuestionAns"
                        mb={2}
                        key={item?.confQuesId}
                      >
                        <strong>{item?.confQues}:</strong>
                        {getValueByKey(item?.confAns)}
                      </Grid>
                    );
                  })}
              </Grid>
            </>
          )}

          {inspectionDetail?.categoriesView?.map((item, i) => {
            return (
              <>
                {item?.skipped === true ? (
                  <div className="overSkipView" key={item?.key}>
                    <Grid container className="skipView categorySkip">
                      <Grid item md={6} sm={6} xs={12} className="skipViewLeft">
                        <div className="skipViewTitle">{item?.value}</div>
                      </Grid>
                      <Grid
                        item
                        md={6}
                        sm={6}
                        xs={12}
                        className="skipViewRight"
                      >
                        <div className="skipViewDesc">Skipped</div>
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  <Grid container className="categoriesView">
                    <Grid key={i} item md={12} className="categoriesTitle">
                      <Grid>{item?.value}</Grid>
                    </Grid>

                    {item?.subcategoriesView?.map((subItem, i) => {
                      return (
                        <>
                          {subItem?.skipped === true ? (
                            <>
                              <div className="overSkipView" key={subItem?.key}>
                                <Grid
                                  container
                                  className="skipView subCategorySkip"
                                >
                                  <Grid
                                    item
                                    md={6}
                                    sm={6}
                                    xs={12}
                                    className="skipViewLeft"
                                  >
                                    <div className="skipViewTitle">
                                      {subItem?.value}
                                    </div>
                                  </Grid>
                                  <Grid
                                    item
                                    md={6}
                                    sm={6}
                                    xs={12}
                                    className="skipViewRight"
                                  >
                                    <div className="skipViewDesc">Skipped</div>
                                  </Grid>
                                </Grid>
                              </div>
                            </>
                          ) : (
                            <>
                              <Grid
                                key={i}
                                item
                                md={12}
                                sm={12}
                                xs={12}
                                className="subCategoriesTitle subCatTitleprint"
                              >
                                <Grid>{subItem?.value}</Grid>
                              </Grid>

                              <div className="subCateViewBox">
                                {subItem?.insQuesAnsReportView?.map(
                                  (inQuestion, i) => {
                                    // Show an item if it is still open, or if it
                                    // was closed on THIS report — i.e. its close
                                    // date matches the report's submit/created
                                    // date. Dates arrive in different formats
                                    // (dateClosed "MM-DD-YYYY" vs createdOn
                                    // "YYYY-MM-DD HH:MM:SS"), so normalize both.
                                    // A report is a historical snapshot: show an
                                    // item if it is still open, or if it was
                                    // closed on THIS report or a later one — in
                                    // which case it was still outstanding when
                                    // this report was filed. Items closed on an
                                    // earlier report have had their moment and
                                    // drop off for good.
                                    const filterPreviousData =
                                      inQuestion?.previousOpenItemDetails?.filter(
                                        (item) =>
                                          item.status ===
                                            INSPECTION_STATUS?.Open ||
                                          (item.status ===
                                            INSPECTION_STATUS?.Closed &&
                                            (item.linkedReportId === null ||
                                              item.linkedReportId ===
                                                undefined ||
                                              item.linkedReportId >= reportId)),
                                      );

                                    return (
                                      <>
                                        {inQuestion?.answerMstId === 1 && (
                                          <Grid
                                            key={i}
                                            item
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className="subCateView"
                                          >
                                            <div className="commonInsOveride">
                                              <Grid className="commoninfoWrap">
                                                <Grid
                                                  item
                                                  xs={12}
                                                  md={12}
                                                  sm={12}
                                                  className="listViewBox"
                                                >
                                                  <div className="listDetailBox">
                                                    <div className="listView questionDetail">
                                                      <div className="questions">
                                                        <div>
                                                          <span>
                                                            {inQuestion?.quesNo}
                                                            {"."}{" "}
                                                            {
                                                              inQuestion?.question
                                                            }
                                                          </span>
                                                        </div>
                                                        {inQuestion?.responseType ===
                                                          3 && (
                                                          <ViewThreeQuestion
                                                            inQuestion={
                                                              inQuestion
                                                            }
                                                            getValueByKey={
                                                              getValueByKey
                                                            }
                                                          />
                                                        )}
                                                      </div>
                                                      <div className="questionitem">
                                                        <div>
                                                          {inQuestion?.answerMstId ===
                                                            1 && (
                                                            <>
                                                              <div className="acceptableBtn commonBtn">
                                                                Acceptable
                                                              </div>
                                                            </>
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </Grid>
                                              </Grid>
                                            </div>
                                            {filterPreviousData?.length > 0 && (
                                              <Grid
                                                container
                                                item
                                                className="itemFoundLocation"
                                                md={12}
                                                xs={12}
                                                sm={12}
                                              >
                                                <div className="viewReportIns">
                                                  <div className="title">
                                                    Previous Open Items
                                                  </div>
                                                  <table>
                                                    <thead>
                                                      <tr className="tableHead">
                                                        <th>Location</th>
                                                        <th>Item Found</th>
                                                        <th>Media</th>
                                                        <th>Status</th>
                                                        <th className="swinspectiondownloadprint">
                                                          Comment
                                                        </th>
                                                        <th className="swinspectiondownloadprint">
                                                          Date Corrected
                                                        </th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      <PreviousOpenItem
                                                        filterPreviousData={
                                                          filterPreviousData
                                                        }
                                                        reportId={reportId}
                                                      />
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </Grid>
                                            )}
                                          </Grid>
                                        )}
                                        {inQuestion?.answerMstId === 2 && (
                                          <>
                                            <Grid
                                              key={i}
                                              item
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              className="subCateView"
                                            >
                                              <div className="commonInsOveride">
                                                <Grid className="commoninfoWrap">
                                                  <Grid
                                                    item
                                                    sm={12}
                                                    xs={12}
                                                    md={12}
                                                    className="listViewBox"
                                                  >
                                                    <div className="listDetailBox">
                                                      <div className="listView questionDetail">
                                                        <div className="questions">
                                                          <div>
                                                            <span>
                                                              {
                                                                inQuestion?.quesNo
                                                              }
                                                              {"."}{" "}
                                                              {
                                                                inQuestion?.question
                                                              }
                                                            </span>
                                                          </div>
                                                          {/* <div>
                                                            <span className="openItemCount">
                                                              Open Item Count
                                                            </span>
                                                          </div> */}
                                                        </div>
                                                        <div className="questionitem">
                                                          <div>
                                                            {inQuestion?.answerMstId ===
                                                              2 && (
                                                              <>
                                                                <div className="notAcceptableBtn commonBtn">
                                                                  Not Acceptable
                                                                </div>

                                                                {/* {inQuestion
                                                                  ?.previousOpenItemDetails
                                                                  ?.length >
                                                                  0 && (
                                                                  <div>
                                                                    <div className="countBtnSw">
                                                                      {findCount(
                                                                        inQuestion?.previousOpenItemDetails
                                                                      )}
                                                                    </div>
                                                                  </div>
                                                                )} */}
                                                              </>
                                                            )}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </Grid>
                                                </Grid>
                                              </div>

                                              <Grid
                                                container
                                                item
                                                className="itemFoundLocation"
                                                md={12}
                                                xs={12}
                                                sm={12}
                                              >
                                                <div className="viewReportIns">
                                                  {inQuestion?.detailsReportView?.some(
                                                    (item) => item?.itemFoundId,
                                                  ) && (
                                                    <div className="title">
                                                      New Open Items
                                                    </div>
                                                  )}

                                                  <table>
                                                    {inQuestion?.detailsReportView?.some(
                                                      (item) =>
                                                        item?.itemFoundId,
                                                    ) && (
                                                      <tr className="tableHead">
                                                        <th>Location</th>
                                                        <th>Item Found</th>
                                                        <th>Media</th>
                                                        <th>Status</th>
                                                      </tr>
                                                    )}

                                                    <NewOpenItem
                                                      inQuestion={inQuestion}
                                                      reportId={reportId}
                                                    />
                                                  </table>
                                                </div>
                                              </Grid>

                                              {filterPreviousData?.length > 0 && (
                                                <Grid
                                                  container
                                                  item
                                                  className="itemFoundLocation"
                                                  md={12}
                                                  xs={12}
                                                  sm={12}
                                                >
                                                  <div className="viewReportIns">
                                                    <div className="title">
                                                      Previous Open Items
                                                    </div>
                                                    <table>
                                                      <thead>
                                                        <tr className="tableHead">
                                                          <th>Location</th>
                                                          <th>Item Found</th>
                                                          <th>Media</th>
                                                          <th>Status</th>

                                                          <th className="swinspectiondownloadprint">
                                                            Comment
                                                          </th>
                                                          <th className="swinspectiondownloadprint">
                                                            Date Corrected
                                                          </th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <PreviousOpenItem
                                                          filterPreviousData={
                                                            filterPreviousData
                                                          }
                                                          reportId={reportId}
                                                        />
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </Grid>
                                              )}

                                              {inQuestion?.responseType ===
                                                3 && (
                                                <ViewThreeQuestion
                                                  inQuestion={inQuestion}
                                                  getValueByKey={getValueByKey}
                                                />
                                              )}
                                            </Grid>
                                          </>
                                        )}
                                        {inQuestion?.answerMstId === 3 && (
                                          <Grid
                                            key={i}
                                            item
                                            md={12}
                                            xs={12}
                                            sm={12}
                                            className="subCateView"
                                          >
                                            <div className="commonInsOveride">
                                              <Grid className="commoninfoWrap">
                                                <Grid
                                                  item
                                                  xs={12}
                                                  md={12}
                                                  className="listViewBox"
                                                >
                                                  <div className="listDetailBox">
                                                    <div className="listView questionDetail">
                                                      <div className="questions">
                                                        <div>
                                                          <span>
                                                            {inQuestion?.quesNo}
                                                            {"."}{" "}
                                                            {
                                                              inQuestion?.question
                                                            }
                                                          </span>
                                                        </div>
                                                        {inQuestion?.responseType ===
                                                          3 && (
                                                          <ViewThreeQuestion
                                                            inQuestion={
                                                              inQuestion
                                                            }
                                                            getValueByKey={
                                                              getValueByKey
                                                            }
                                                          />
                                                        )}
                                                      </div>
                                                      <div className="questionitem">
                                                        <div>
                                                          {inQuestion?.answerMstId ===
                                                            3 && (
                                                            <>
                                                              <div className="notApplicableBtn gray commonBtn">
                                                                N/A
                                                              </div>
                                                            </>
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </Grid>
                                              </Grid>
                                            </div>
                                          </Grid>
                                        )}
                                        {(inQuestion?.answerMstId === 4 ||
                                          inQuestion?.answerMstId === 0) && (
                                          <Grid
                                            key={i}
                                            item
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className="subCateView"
                                          >
                                            <div className="commonInsOveride">
                                              <Grid className="commoninfoWrap">
                                                <Grid
                                                  item
                                                  xs={12}
                                                  md={12}
                                                  sm={12}
                                                  className="listViewBox"
                                                >
                                                  <div className="listDetailBox">
                                                    <Grid
                                                      container
                                                      className="listView"
                                                    >
                                                      <Grid item md={8} xs={12}>
                                                        <Grid>
                                                          <span>
                                                            {inQuestion?.quesNo}
                                                            {"."}{" "}
                                                            {
                                                              inQuestion?.question
                                                            }
                                                          </span>
                                                        </Grid>
                                                        <Grid></Grid>
                                                      </Grid>
                                                      <Grid
                                                        questionitem
                                                        md={12}
                                                        xs={12}
                                                        sm={12}
                                                      >
                                                        {inQuestion?.detailsReportView?.map(
                                                          (itemDetail, i) => {
                                                            return (
                                                              <Grid key={i}>
                                                                <Grid
                                                                  container
                                                                  item
                                                                  className=""
                                                                  md={12}
                                                                  xs={12}
                                                                  sm={12}
                                                                >
                                                                  <Grid
                                                                    md={8}
                                                                    xs={12}
                                                                    sm={8}
                                                                  >
                                                                    {parse(
                                                                      unescape(
                                                                        itemDetail?.details,
                                                                      ),
                                                                    )}
                                                                  </Grid>
                                                                </Grid>
                                                              </Grid>
                                                            );
                                                          },
                                                        )}
                                                      </Grid>
                                                    </Grid>
                                                  </div>
                                                </Grid>
                                              </Grid>
                                            </div>
                                          </Grid>
                                        )}
                                      </>
                                    );
                                  },
                                )}
                              </div>
                            </>
                          )}
                        </>
                      );
                    })}
                  </Grid>
                )}
              </>
            );
          })}

          {(isNorthCarolina || isSouthCarolina) && (
            <ViewNorthCarolina
              swInspectionConfQuestionAns={
                inspectionDetail?.swInspectionConfQuestionAns
              }
              swInspectionCurrentProjectPhase={
                inspectionDetail?.swInspectionCurrentProjectPhase
              }
              swInspectionGroundStabilization={
                inspectionDetail?.swInspectionGroundStabilization
              }
              swInspectionObservation={
                inspectionDetail?.swInspectionObservation
              }
              swInspectionLotDisturbance={
                inspectionDetail?.swInspectionLotDisturbance
              }
              swInspectionNewOrRevisedMeasure={
                inspectionDetail?.swInspectionNewOrRevisedMeasure
              }
              initialName={inspectionDetail?.inspectorName}
              isNorthCarolina={isNorthCarolina}
            />
          )}

          {(inspectionDetail?.signOffMethodType ===
            SIGNOFF_METHOD_TYPE.CERTIFY_STATEMENT ||
            inspectionDetail?.signOffMethodType === 4) && (
            <Grid item container spacing={2} mb={3} mt={3}>
              <Grid item lg={10} textAlign="left">
                <FormControl fullWidth>
                  <div className="typeTxt">
                    <span className="associatedIncidentLabel blackText">
                      {inspectionDetail?.certifyStatement}
                    </span>
                  </div>
                </FormControl>
              </Grid>
            </Grid>
          )}
          {(inspectionDetail?.signOffMethodType ===
            SIGNOFF_METHOD_TYPE.SIGNATURE ||
            inspectionDetail?.signOffMethodType === 4) &&
            inspectionDetail?.signature &&
            inspectionDetail?.signature !== "null" && (
              <Grid container mt={2}>
                <Grid item md={12}>
                  <img
                    src={inspectionDetail?.signature}
                    width={"200px"}
                    alt={inspectionDetail?.signature}
                  />
                </Grid>
              </Grid>
            )}

          <Grid container>
            <Grid md={10} xs={12}>
              <div className="bottomBox"></div>
            </Grid>
          </Grid>
        </>
      )}
      <Grid item md={12} className="hideinprint">
        <BackBtn dataBack={dataBack} />
      </Grid>
    </div>
  );
};

export default ViewReport;
